var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVibrator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_4393)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1250_4393",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7H7V23H23V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1250_4393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 12.333L9.66634 13.6663L8.33301 14.9997L9.66634 16.333L8.33301 17.6664M21.6663 12.333L20.333 13.6663L21.6663 14.9997L20.333 16.333L21.6663 17.6664",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 10.333H12.9997C12.6315 10.333 12.333 10.6315 12.333 10.9997V18.9997C12.333 19.3679 12.6315 19.6664 12.9997 19.6664H16.9997C17.3679 19.6664 17.6663 19.3679 17.6663 18.9997V10.9997C17.6663 10.6315 17.3679 10.333 16.9997 10.333Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_4393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibrator);
export default __webpack_public_path__ + "static/media/Vibrator.3e2c3508eb55213f08482c52ff4d30ad.svg";
export { ForwardRef as ReactComponent };